import { HrCommonAuthority } from './hr-common-authority';
import { combineAuth } from './hr-authority';

export class PerformanceAuthority extends HrCommonAuthority {
    public static readonly PERFORMANCE_BASE = 'performance';

    constructor(authority: string) {
        super(combineAuth(PerformanceAuthority.PERFORMANCE_BASE, authority));
    }
}
